import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-purple-200 text-gray-900">
      
      

      {/* Hero Section */}
      <header className="flex flex-col justify-center items-center text-center py-28 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 rounded-b-3xl shadow-xl">
        <h2 className="text-5xl font-extrabold md:text-6xl">Contact Us</h2>
        <p className="mt-4 text-xl md:text-2xl max-w-3xl">
          Have questions? Get in touch with us for any inquiries or assistance.
        </p>
      </header>

      {/* Contact Details */}
      <section className="py-16 px-6 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
        {[
          { Icon: Mail, title: "Email Us", info: "support@skinai.com" },
          { Icon: Phone, title: "Call Us", info: "+1 234 567 890" },
          { Icon: MapPin, title: "Visit Us", info: "123 AI Street, Tech City, USA" },
        ].map(({ Icon, title, info }, index) => (
          <div key={index} className="p-8 bg-white rounded-3xl shadow-xl flex flex-col items-center hover:scale-105 transition-transform duration-300">
            <Icon className="h-16 w-16 text-blue-600 mb-4" />
            <h3 className="text-2xl font-bold">{title}</h3>
            <p className="text-gray-600 mt-2">{info}</p>
          </div>
        ))}
      </section>

      {/* Contact Form */}
      <section className="py-16 px-6 max-w-4xl mx-auto bg-white rounded-3xl shadow-xl text-center">
        <h3 className="text-3xl font-bold text-gray-800">Send Us a Message</h3>
        <form className="mt-6 space-y-4">
          <input type="text" placeholder="Your Name" className="w-full p-3 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500" />
          <input type="email" placeholder="Your Email" className="w-full p-3 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500" />
          <textarea placeholder="Your Message" rows="4" className="w-full p-3 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500"></textarea>
          <button type="submit" className="w-full bg-blue-600 text-white py-3 rounded-lg text-lg font-medium hover:bg-blue-700 transition">Send Message</button>
        </form>
      </section>
    </div>
  );
}
